import { useGlobalStore } from "@/store/GlobalStore";
import { useSubAccountStore } from "@/store/SubAccountStore";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useForm } from "antd/lib/form/Form";
import { TransferItem } from "antd/lib/transfer";
import { useState, useRef } from "react";
import ProjectAPI from "../api";
import { useProjectStore } from "../store/project-store";
import { message } from "antd";
import { IProjectForm, ITransferProps } from "../types";
import { ParamsType } from "../components/add-or-edit-project-drawer";
import {
  removeDataByValue,
  getObjectValue,
  setObjectValue,
  getObjectAllValues,
} from "../helper";

const initParams = {
  renderNum: 1,
  taskOverTime: 12,
  munuTaskOverTime: 24,
};
export function useAddProject() {
  const t = getTranslateNsT("center");
  const { userInfo, isSubAccount } = useGlobalStore();
  const [dataSource, setDataSource] = useState<TransferItem[]>([]);
  const [targetKeys, setTargetKeys] = useState<ITransferProps[]>([]);
  const { subAccountList } = useSubAccountStore();
  const [projectForm] = useForm<IProjectForm>();
  const [open, setOpen] = useState(false);
  const {
    fetchProjectData,
    subDingtalkDatas,
    originDingTalkData,
    setSubDingtalkDatas,
    setSumbitLoading,
  } = useProjectStore();
  const [params, setParams] = useState<any>(initParams);
  const subDingtalkDatasyRef = useRef(subDingtalkDatas);
  const onStateChange = (state: boolean) => {
    setOpen(state);
    if (!state) {
      projectForm.resetFields();
      setParams(initParams);
    }
  };
  const handleRemoveChange = ({
    text,
    id,
    isDingTalkOriganize,
    deptId,
  }: {
    text: string;
    id: string;
    isDingTalkOriganize?: boolean;
    deptId?: string | number;
  }) => {
    setTargetKeys(targetKeys.filter((item) => item.id !== id));
    if (isDingTalkOriganize) {
      if (!deptId || !Array.isArray(deptId)) return;
      subDingtalkDatasyRef.current = subDingtalkDatas;
      deptId.forEach((item: string | number) => {
        const result = getObjectValue(
          JSON.parse(JSON.stringify(originDingTalkData)),
          ["id", "realDeptId"],
          [id, item]
        );
        const finishData = setObjectValue(
          JSON.parse(JSON.stringify(subDingtalkDatasyRef.current)),
          "deptId",
          item,
          result
        );
        subDingtalkDatasyRef.current = finishData;
      });
      setSubDingtalkDatas(subDingtalkDatasyRef.current);
      return;
    }
    setDataSource([
      ...dataSource,
      ...[
        {
          key: text,
          title: text,
          description: id ?? "",
        },
      ],
    ]);
  };
  const onSelectChange = (sourceSelectedKeys: ITransferProps[]) => {
    const { isDingTalkOriganize, ...result } = sourceSelectedKeys[0];

    if (!result.id) return;
    if (isDingTalkOriganize) {
      const targetKey = Array.from(
        new Set(
          getObjectAllValues(subDingtalkDatas, "id", result.id, "realDeptId")
        )
      );
      sourceSelectedKeys[0].deptIdList = targetKey as number[];
      const finishData = removeDataByValue(subDingtalkDatas, "id", result.id);
      setSubDingtalkDatas(finishData);
    } else {
      setDataSource(
        dataSource.filter((item) => item.description !== result.id)
      );
    }
    setTargetKeys([...targetKeys, ...sourceSelectedKeys]);
  };
  const onOpen = () => {
    onStateChange(true);
    const dataSourceTemp = subAccountList.map((i: any) => ({
      key: i.subUserName,
      title: i.subUserName,
      description: i.id,
    }));
    setDataSource(dataSourceTemp);
    setTargetKeys([]);
    setOpen(true);
  };
  const onAdd = () => {
    setSumbitLoading(true);
    const submitParams: any = {
      renderNumStatus: 0,
      taskOverTimeStatus: 0,
      munuTaskOverTimeStatus: 0,
      ...projectForm.getFieldsValue(),
    };
    submitParams.paramsLocked?.map((item: string) => {
      submitParams[item] =
        item === ParamsType.RenderNum ? +params[item] : params[item] * 3600;
      submitParams[item + "Status"] = 1;
      return item;
    });
    submitParams.ids = targetKeys.map((item) => item.id);

    delete submitParams.paramsLocked;
    projectForm
      .validateFields()
      .then(() => {
        ProjectAPI.addProject({ ...submitParams, type: 1 }).then((res) => {
          setSumbitLoading(false);
          if (res.result) {
            message.success(t("user_com_childPro_msg_add_success"));
            onStateChange(false);
            fetchProjectData();
          }
          if (res.code === 503) {
            message.error(t("render_project_name_not_same"));
          }
        });
      })
      .catch(() => {
        setSumbitLoading(false);
      });
  };
  return {
    userInfo,
    isSubAccount,
    onSelectChange,
    onOpen,
    dataSource,
    setDataSource,
    targetKeys,
    setTargetKeys,
    open,
    onAdd,
    onStateChange,
    projectForm,
    params,
    setParams,
    handleRemoveChange,
  };
}
